import { render, staticRenderFns } from "./MetadataSnippet.vue?vue&type=template&id=55fbf850&lang=pug&"
import script from "./MetadataSnippet.vue?vue&type=script&lang=js&"
export * from "./MetadataSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports